module.exports = __webpack_public_path__ + "static/media/download-solid.29edbd0f.svg";